import './ExpandableText.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var expandableTextButtonCSS = '_95ptdy3-2-0-1';
export var expandableTextCSS = _7a468({defaultClassName:'_95ptdy0-2-0-1',variantClassNames:{expanded:{true:'_95ptdy1-2-0-1',false:'_95ptdy2-2-0-1'}},defaultVariants:{},compoundVariants:[]});